import axios from 'axios';

// 应用ID - 确保这个ID正确
const APP_ID = '27dc9d32200d4a59ade097778a894605';

// 发送消息到问答API - 使用相对URL
export const sendMessage = async (prompt, sessionId = null) => {
  try {
    console.log('发送问答请求:', { prompt, sessionId });
    
    // 确保请求格式正确
    const requestData = {
      prompt: prompt
    };
    
    // 如果有会话ID，添加到请求中
    if (sessionId) {
      requestData.session_id = sessionId;
    }
    
    console.log('发送到后端的请求数据:', requestData);
    
    // 使用相对URL，而不是硬编码的localhost
    const response = await axios.post('/api/chat', requestData);
    
    console.log('问答响应状态:', response.status);
    console.log('问答响应数据:', response.data);
    
    // 确保响应格式正确
    if (!response.data || !response.data.success) {
      console.error('响应格式不正确或请求不成功:', response.data);
      throw new Error(response.data?.message || '问答失败');
    }
    
    return {
      output: response.data.output,
      session_id: response.data.session_id || sessionId
    };
  } catch (error) {
    console.error('问答错误:', error);
    
    if (error.response) {
      console.error('响应错误状态:', error.response.status);
      console.error('响应错误数据:', error.response.data);
    }
    
    throw new Error(error.response?.data?.message || '问答服务暂时不可用，请稍后再试');
  }
};

// 创建新会话 - 确保正确处理响应
export const createNewSession = async () => {
  try {
    // 发送一个初始问候消息创建会话
    const response = await sendMessage('你好，我想问几个问题');
    console.log('创建会话响应:', response);
    return response.session_id;
  } catch (error) {
    console.error('创建会话失败:', error);
    throw error; // 重要：将错误向上传播，以便在上下文中处理
  }
};

// 如果需要直接调用百炼API的备用函数，使用不同的名称
export const sendMessageDirect = async (message, sessionId = null) => {
  try {
    // 直接调用百炼应用API
    const apiKey = 'sk-c4e0665e71d34746999da6260362d0f4';
    const appId = '27dc9d32200d4a59ade097778a894605';
    
    const response = await fetch(`https://dashscope.aliyuncs.com/api/v1/apps/${appId}/completion`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiKey}`
      },
      body: JSON.stringify({
        input: {
          prompt: message,
          session_id: sessionId
        },
        parameters: {}
      })
    });
    
    const data = await response.json();
    
    return {
      success: true,
      output: data.output,
      session_id: data.output.session_id || sessionId || null
    };
  } catch (error) {
    console.error('发送消息错误:', error);
    throw error;
  }
}; 